import * as Scrivito from "scrivito";

const LoginWidget = Scrivito.provideWidgetClass("LoginWidget", {});

export default LoginWidget;
